module.exports = __webpack_public_path__ + "static/homepage_hero2-83c48676ea4451576989b8d8545b14cc.png";